'use strict';

module.exports = lineBreak;

var map = {true: '\\\n', false: '  \n'};

function lineBreak() {
  return map[this.options.commonmark];
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/break.js
// module id = 284
// module chunks = 147254134005266 182246549230831 215303740077764